import React from 'react'
import PageLayout from '../../components/layout/PageLayout'
import UserInfoContainer from '../../features/page/user/UserInfoContainer'
import UserCopyTradingContainer from '../../features/page/user/UserCopyTradingContainer'
import {useSearchParams} from 'react-router-dom'
import UserApiContainer from '../../features/page/user/UserApiContainer'
import useQueryUserDetail from '../../hooks/api/user/useQueryUserDetail'

interface IProps {
    className?: string
}

const ProDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const userId = searchParams.get('id')

    const {data, refetch} = useQueryUserDetail(userId)

    return (
        <PageLayout title={'Pro Info'} className={'grid grid-cols-[auto_450px] space-x-[30px]'}>
            <div className={'space-y-[30px]'}>
                <UserInfoContainer data={data} refetch={refetch} />
                <UserCopyTradingContainer userId={userId} />
            </div>
            <div>
                <UserApiContainer data={data} />
            </div>
        </PageLayout>
    )
}

export default ProDetailPage
